import React, { useEffect, useState, useContext } from "react";
import { HashLoader } from "react-spinners";
import PageHeader from "../pageheader/PageHeader";
import styles from "./GuidelineTextEditor.module.css";
import MenuDoctor from "./navDoctor/MenuDoctor";
import Input from "../material/input/Input";
import Button from "../material/button/Button";
import TextEditor from "../material/textEditor/TextEditor";
import * as medicalApi from "../../service/medicalApi";
import { useLocation, useNavigate } from "react-router-dom";
import { RedirectCode400 } from "../RedirectCode400";

import { CurrentUserContext } from "../../App";

const AddGuideline = () => {
  const { setIsMessage } = useContext(CurrentUserContext);

  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("add"); // add, view
  const [title, setTitle] = useState("");
  const [detail, setDetail] = useState("");

  const nav = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.type) {
      setType(location.state?.type);

      if (location.state?.type === "view") {
        // console.log(location.state);
        setTitle(location.state?.title);
        setDetail(location.state?.detail);
      }
    }
  }, []);

  const saveButton = () => {
    if (!title) {
      setIsMessage({ type: "warning", data: "กรุณากรอกหัวข้อ" });
      return;
    } else if (!detail) {
      setIsMessage({ type: "warning", data: "กรุณากรอกรายละเอียด" });
      return;
    } else {
      if (window.confirm("ยืนยันการบันทึก")) {
        addGuideline(title, detail);
      }
    }
  };

  const addGuideline = async (title, detail) => {
    setLoading(true);
    let res = await medicalApi.addGuideline(title, detail);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({ type: "success", data: "สำเร็จ" });
        nav("/guideCheckInspec", {
          state: {
            type: "guide",
          },
        });
      } else if (res["data"]["code"] === 403) {
        nav(RedirectCode400());
      } else {
        // console.log(res["data"]["message_th"] || res["data"]["message"]);
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  return (
    // <HashLoader loading={loading} style={{ display: 'flex', justifyContent: 'center' }} color="#FF9768" />
    // <MenuDoctor menuActive={'guideCheckInspec'} />
    // <PageHeader
    //     titlename={type === 'add' ? 'เพิ่มแนวทางการตรวจ' : (type === 'view' ? 'แนวทางการตรวจ' : '-')}
    //     btnBackWard={true}
    //     backpath={'/guideCheckInspec'}
    //     type={'guide'}
    // />
    <div class="flex w-full bg-[#ffffff] pb-[30px]">
      <div className={styles.blockContent}>
        <div
          className={`text-3xl md:text-[18px] flex font-bold mt-2 mb-4 font-['Prompt-SemiBold']`}
        >
          {type === "add"
            ? "เพิ่มแนวทางการตรวจ"
            : type === "view"
              ? "แนวทางการตรวจ"
              : "-"}
        </div>

        <div className={styles.blocktable}>
          <Input
            style={{ marginBottom: 20 }}
            value={title}
            setValue={setTitle}
            label={"หัวข้อ"}
          />

          {type === "add" ? (
            <TextEditor
              label={"รายละเอียดเพิ่มเติม"}
              value={detail}
              setValue={setDetail}
              placeholder={"รายละเอียด..."}
            />
          ) : null}
          {type === "view" ? (
            <TextEditor
              label={"รายละเอียดเพิ่มเติม"}
              value={detail}
              readOnly={true}
            />
          ) : null}

          {type === "add" ? (
            <div className="flex justify-center my-6">
              <button
                onClick={() => {
                  saveButton();
                }}
                className="button-theme-pg flex justify-center items-center w-48 h-10 bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl gap-1 text-[#000000] shadow-sm shadow-brand-cyan "
              >
                บันทึก
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default AddGuideline;
